<template>
<div class="chapter">
<div class="inner_page">
<p class="center_5">There are night clubs like The Casino, and there is a city called Chicago, and perhaps by now Jake Justus, Helene, and John J. Malone are as real as other people. With these exceptions I’ll have to admit that the characters and events in this book were all dreamed up. If they resemble any actual persons or parties I wouldn’t be surprised.</p>
<p class="right">C<span class="small">RAIG</span> R<span class="small">ICE</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?e1cb40f2